const AndroidIcon = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='16.125' cy='15.125' r='1.125' fill='var(--theme-primary, #810ea9)' />
      <circle cx='9.375' cy='15.125' r='1.125' fill='var(--theme-primary, #810ea9)' />
      <path
        clipRule='evenodd'
        d='M3 18.5v-2.144c0-5.389 4.327-9.837 9.716-9.856a9.75 9.75 0 0 1 9.784 9.75v2.25a.75.75 0 0 1-.75.75h-18A.75.75 0 0 1 3 18.5z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m3.75 5.75 2.913 2.913M21.75 5.75l-2.896 2.897'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AndroidIcon;
